<template>
  <div class="page-content">
   <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Configure Server</h4>
               <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                     <li class="breadcrumb-item"><a>Your Server</a></li>
                     <li class="breadcrumb-item active">Configure</li>
                  </ol>
               </div>
            </div>
         </div>
      </div>
      <!-- end page title -->
      <div class="row justify-content-center">
         <div class="col-lg-6">
            <div class="text-center mb-5">
               <h4>Select Location</h4>
               <p class="text-muted">Select your desired location out of our currently available and ready-to-deploy destinations.</p>
            </div>
         </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center">
         <div class="col-xl-2 col-sm-4">
            <div class="mb-3">
               <label class="card-radio-label mb-2">
                  <input type="radio" name="location" id="losangeles" class="card-radio-input" checked>
                  <div class="card-radio">
                     <div>
                        <img class="avatar-sm" src="../../assets/images/flags/us.svg" alt="" style="padding-right: 10px">
                        <span>Los Angeles, USA</span>
                     </div>
                  </div>
               </label>
            </div>
         </div>
         <div class="col-xl-2 col-sm-4">
            <div class="mb-3">
               <label class="card-radio-label mb-2">
                  <input type="radio" name="location" id="london" class="card-radio-input not-allowed" disabled>
                  <div class="card-radio">
                     <div>
                        <img class="avatar-sm" src="../../assets/images/flags/unitedkingdom.svg" alt="" style="padding-right: 10px">
                        <span>London, UK</span>
                     </div>
                  </div>
               </label>
            </div>
         </div>
         <div class="col-xl-2 col-sm-4">
            <div class="mb-3">
               <label class="card-radio-label mb-2">
                  <input type="radio" name="location" id="amsterdam" class="card-radio-input">
                  <div class="card-radio">
                     <div>
                        <img class="avatar-sm" src="../../assets/images/flags/netherlands.svg" alt="" style="padding-right: 10px">
                        <span>Amsterdam, NL</span>
                     </div>
                  </div>
               </label>
            </div>
         </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center" style="padding-top: 50px">
         <div class="col-lg-6">
            <div class="text-center mb-5">
               <h4>Additional Settings</h4>
               <p class="text-muted">Adjust to select your desired configuration. These settings can be changed later in your dashboard.</p>
            </div>
         </div>
      </div>
      <!--end row-->
      <div class="row">
         <div class="col-lg-6">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title">Server Subdomain</h4>
                  <p class="card-title-desc">Choose your own custom subdomain to join your server with.</p>
                  <div>
                     <div class="input-group mb-4">
                        <input class="form-control" type="text" placeholder="Enter desired subdomain here" value="">
                        <div class="input-group-prepend">
                           <span class="input-group-text" id="option-date">.spc.mn</span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-lg-6">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title">Select Version</h4>
                  <p class="card-title-desc">Select your desired server version.</p>
                  <div>
                     <div class="input-group mb-4">
                        <select class="form-control">
                           <option>Minecraft 1.16.2</option>
                           <option>Minecraft 1.16.1</option>
                           <option>Minecraft 1.15.2</option>
                           <option>Minecraft 1.15.1</option>
                           <option>Minecraft 1.14.2</option>
                           <option>Minecraft 1.14.1</option>
                           <option>Minecraft 1.13.2</option>
                           <option>Minecraft 1.13.1</option>
                        </select>
                        <div class="input-group-prepend">
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center">
         <div class="col-lg-6">
            <div class="text-center mb-5">
               <a href="dashboard.html"><button type="button" class="btn btn-primary waves-effect waves-light">
               DEPLOY NOW
               </button></a>
            </div>
         </div>
      </div>
      <!-- end row -->
      <!-- end row -->
      <!-- end row -->
      <!-- end row -->
   </div>
</div>
</template>

<script>
export default{
  name: 'Configure',
  data () {
    return { }
  }
}</script>

<style scoped>
.not-allowed {cursor: not-allowed;}
</style>



// WEBPACK FOOTER //
// src/components/management/Configure.vue